import { EmpLeavesResponse, EmployeeLeavesResponse, GetAllAvailableLeavesResponseModel } from '@gtpl/shared-models/hrms';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { EmployeeLeavesCreateDTO } from './dto/employee-leaves-create.dto';
import { GetEmpAvlLeaves } from './dto/get-emp-avl-leaves.dto';
import { GetEmpLeaves } from './dto/get-emp-leaves.dto';
import { EmployeeLeavesService } from './employee-leaves.service';

@Controller('employee-leaves')
@ApiTags('employee-leaves')
export class EmployeeLeavesController {
    constructor(
        private service: EmployeeLeavesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/createEmployeeLeaves')
    async createEmployeeLeaves(@Body() dto: EmployeeLeavesCreateDTO): Promise<CommonResponse> {
        try {
            return await this.service.createEmployeeLeaves(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getAllEmployeeLeaves')
    async getAllEmployeeLeaves(@Body() getDto: GetEmpLeaves): Promise<EmpLeavesResponse> {
        try {
            return await this.service.getAllEmployeeLeaves(getDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(EmpLeavesResponse, error);
        }
    }
    @Post('getAllAvailableLeaves')
    async getAllAvailableLeaves(@Body() req: GetEmpAvlLeaves): Promise<GetAllAvailableLeavesResponseModel> {
        try {
            return await this.service.getAllAvailableLeaves(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllAvailableLeavesResponseModel, error);
        }
    }

    @Post('getLeavesData')
    async getLeavesData(): Promise<EmployeeLeavesResponse> {
        try {
            return this.service.getLeavesData()
        } catch (error) {
            return this.applicationExceptionHandler.returnException(EmployeeLeavesResponse, error);
        }


    }
    
    @Post('HolidayCalander')
    async HolidayCalander(): Promise<CommonResponse> {
        try {
            return this.service.HolidayCalander()
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }


    }




}
